import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { opportunityStore } from './opportunity'

export const adasStore = defineStore({
  id: 'adas',
  state: () => ({
    loading: {
      vehicleInfo: false,
      inspectionInfo: false,
      repairLines: false,
      report: false,
      invoice: false
    },
    vehicleInfo: null,
    inspectionInfo: {
      adas: null,
      adasInspection: null,
      adasInspectionType: null,
      estimator: null,
      firm: null,
      inspectionDate: null,
      insurance: null,
      repair: null,
      repairLineCount: 0,
      results: [],
      ronumber: null,
      status: null,
      totalAmount: 0,
      vehicle: {
        vehicle: null,
        year: null,
        make: null,
        model: null,
        vin: null
      }
    },
    repairLines: null
  }),
  actions: {
    recalcRevenueShareFee() {
      if (this.inspectionInfo) {
        this.inspectionInfo.price = 0
        this.inspectionInfo.offerPrice = 0
        this.inspectionInfo.discount = 0
        this.inspectionInfo.results.forEach((element) => {
          this.inspectionInfo.price += parseFloat(element.price)
          this.inspectionInfo.offerPrice += parseFloat(element.offerPrice)
          this.inspectionInfo.discount += parseFloat(element.discount)
        })
        this.inspectionInfo.revenueShareFee = this.inspectionInfo.fee || 0
      }
    },
    setInspection(data) {
      if (this.inspectionInfo !== undefined && this.inspectionInfo !== null) {
        switch (data.name) {
          case 'line': {
            let found = this.inspectionInfo.results.find((element) => parseInt(element.id) === parseInt(data.value.id))
            if (found) {
              this.inspectionInfo.isOffer = true
              found.offerPrice = data.value.offerPrice
              found.isOverride = true
            }
            let offerPrice = 0
            this.inspectionInfo.results.forEach((element) => {
              offerPrice += parseFloat(element.offerPrice)
            })
            this.inspectionInfo.offerPrice = offerPrice
            this.recalcRevenueShareFee()
            break
          }
          case 'notes': {
            this.inspectionInfo.notes = data.value
            break
          }
          case 'status': {
            this.inspectionInfo.status = data.value
            break
          }
          case 'reason': {
            this.inspectionInfo.reason = data.value
            break
          }
          case 'reasonSource': {
            this.inspectionInfo.reasonSource = data.value
            break
          }
          case 'completed': {
            this.inspectionInfo.completedDate = data.value
            break
          }
          default:
            this.inspectionInfo[data.name] = data.value
        }
        console.log('Set Inspection Info', this.inspectionInfo)
      }
    },
    async getVehicleInfo(vin) {
      this.vehicleInfo = null
      this.loading.vehicleInfo = true
      let response = await api.get(`dashboard/searchByVin?vin=${vin}`)
      this.loading.vehicleInfo = false
      if (response) {
        if (response !== '') {
          this.vehicleInfo = response
        }
      }
    },
    async getAdasInspection(data) {
      const storeOpportunity = opportunityStore()
      this.inspectionInfo = null
      this.loading.adasInspection = true
      let response = await api.get(`dashboard/clientInspection?adasInspection=${data.adasInspection}&source=${data.source}`)
      this.loading.adasInspection = false
      console.log('Got ADAS Inspection', response)
      if (response !== null && response !== undefined) {
        if (response !== '') {
          this.inspectionInfo = response
          this.inspectionInfo.isInsurer = data.isInsurer
          // #675: clientInspection returns every identified system (isRequired / isNotEquipped flags).
          // Keep that list intact; the opportunity rebuild below replaces results with priced lines.
          this.inspectionInfo.identifiedResults = Array.isArray(response.results) ? response.results : []
          if (data.isInsurer && data.opportunity) {
            // Insurer path: fetch opportunity to get the persisted fee
            const storeOpp = opportunityStore()
            let opp = await storeOpp.getOpportunity({ opportunity: data.opportunity, adasInspection: null })
            if (opp && opp !== '') {
              this.inspectionInfo.fee = opp.fee
              this.inspectionInfo.revenueShareFee = opp.fee || 0
            }
          }
          if (!this.inspectionInfo.isInsurer) {
            let opportunity = await storeOpportunity.getOpportunity({
              opportunity: data.opportunity,
              adasInspection: null
            })
            if (opportunity) {
              if (opportunity !== '') {
                this.inspectionInfo.expiresOn = opportunity.expiresOn
                this.inspectionInfo.completedDate = opportunity.completed
                this.inspectionInfo.isAccepted = opportunity.isAccepted
                this.inspectionInfo.isOffer = opportunity.isOffer
                this.inspectionInfo.isPriceIncluded = opportunity.isPriceIncluded
                this.inspectionInfo.isPushed = opportunity.isPushed
                this.inspectionInfo.numAdas = opportunity.numAdas
                this.inspectionInfo.numCalibration = opportunity.numCalibration
                this.inspectionInfo.price = opportunity.price
                this.inspectionInfo.offerPrice = opportunity.offerPrice
                this.inspectionInfo.discount = opportunity.discount
                this.inspectionInfo.providerFirm = opportunity.firm
                this.inspectionInfo.providerName = opportunity.providerName
                this.inspectionInfo.calibrateRequest = opportunity.calibrateRequest
                this.inspectionInfo.scheduledOn = opportunity.scheduledOn
                this.inspectionInfo.preferredTimeOfDay = opportunity.preferredTimeOfDay
                this.inspectionInfo.bay = opportunity.bay
                this.inspectionInfo.technicians = opportunity.technicians
                this.inspectionInfo.notes = opportunity.notes
                this.inspectionInfo.opportunity = opportunity.opportunity
                this.inspectionInfo.status = opportunity.status
                this.inspectionInfo.files = opportunity.files
                this.inspectionInfo.vehicleMake = opportunity.vehicleMake ?? null
                this.inspectionInfo.reason = opportunity.reason
                this.inspectionInfo.reasonSource = opportunity.reasonSource
                this.inspectionInfo.isNoFee = opportunity.isNoFee
                this.inspectionInfo.fee = opportunity.fee
                // #539: pricing source badge — resolved by Opportunity_Get from
                // CalibrateRequest.IsPriceIncluded (the same flag that picks the line prices).
                this.inspectionInfo.pricingSource = opportunity.pricingSource
                this.inspectionInfo.pricingDetail = opportunity.pricingDetail
                if (opportunity.lines.length > 0) {
                  this.inspectionInfo.results = []
                  this.inspectionInfo.isOpportunityLines = true
                  let total = 0
                  let totalPrice = 0
                  opportunity.lines.forEach((element) => {
                    if (element.adasInspectionResult !== null) {
                      let price = 0
                      if (element.calibrationPrice) {
                        price = parseFloat(element.calibrationPrice)
                      }
                      let offerPrice = 0
                      if (element.offerPrice !== null) {
                        offerPrice = parseFloat(element.offerPrice)
                      } else {
                        offerPrice = price
                      }
                      this.inspectionInfo.results.push({
                        id: element.adasInspectionResult,
                        calibrateRequestItem: element.calibrateRequestItem,
                        calibration: element.calibrationTypeName,
                        category: element.item,
                        location: element.location,
                        showInfo: 1,
                        showVideo: 0,
                        source: 1,
                        system: element.attribute,
                        amount: price,
                        price: price,
                        offerFee: element.offerFee,
                        offerPrice: offerPrice,
                        discount: element.discount,
                        isUserInstalled: element.isUserInstalled || false
                      })
                    }
                  })
                }
              }
              this.recalcRevenueShareFee()
              console.log('Applied Opportunity', this.inspectionInfo)
            }
          }
        }
      } else {
        this.inspectionInfo = 'noData'
      }
    },
    async getRepairLines(source, adas, adasInspection) {
      this.repairLines = null
      this.loading.repairLines = true
      if (adas) {
        // Issue 431: pass adasInspection so the API scopes repair lines to THIS inspection's own
        // workfile, not the parent Adas.Repair (which mixes in sibling inspections' lines).
        let url = `dashboard/repairlines?adas=${adas}&source=${source}`
        if (adasInspection) {
          url += `&adasInspection=${adasInspection}`
        }
        let response = await api.get(url)
        this.loading.repairLines = false
        if (response) {
          if (response !== '') {
            this.repairLines = response
          }
        }
      }
    },
    async inspectionReport(source, adasInspection) {
      this.loading.report = true
      api.isTypeFile = true
      let report = await api.get(`report/inspection?source=${source}&adasInspection=${adasInspection}`, 'file')
      this.loading.report = false
      return report
    },
    async inspectionInvoice(source, adasInspection, pricing, provider) {
      this.loading.invoice = true
      api.isTypeFile = true
      let report = await api.post('report/invoice', {
        source: source,
        adasInspection: adasInspection,
        pricing: JSON.stringify(pricing),
        provider: JSON.stringify(provider)
      }, 'file')
      this.loading.invoice = false
      return report
    }
  }
})
